(function ($) {
    $(document).ready(function () {
        /**
         * Click event for opening and closing store info in menu - mobile device
         * 
         */
        $('.mm__store_wrapper .menu-chosen-store .show-on-mob').on('click', function () {
            $(this).parent().children('.show-on-desktop').slideToggle({
                duration: 300,
                start: function () {
                    $(this).css('display', 'flex');
                }
            });
            $(this).toggleClass('rotated');
        });

        /**
         * Click event for opening and closing the top layer in menu - mobile device
         * 
         */
        $('.mm__header_menu_wrapper .menu-icons .hamburger-icon').click(function (e) {
            e.preventDefault();

            // Trigger only on mobile devices
            if (576 < $(window).width()) {
                return;
            }

            if (!$('.mm__header_menu_wrapper #header-navigation').hasClass('is-active')) {
                $('.mm__header_menu_wrapper #header-navigation').addClass('is-active');

                if (!$('.mm__header_menu_wrapper #primary-menu :first-child').hasClass('close')) {
                    $('.mm__header_menu_wrapper #primary-menu').prepend($('<li class="close"></li>'))
                }

                if (!$('.mm__header_menu_wrapper #primary-menu :last-child').hasClass('show-on-mob')) {
                    $('.mm__header_menu_wrapper #primary-menu').append($(
                        `
                        <li class="show-on-mob login"><a href="${wpurl.mypages}">Logga in</a></li>
                        <li class="show-on-mob fav"><a href="#" class="fav-list">Favoriter</a></li>
                        `
                    ));

                    $('.mm__header_menu_wrapper #primary-menu .show-on-mob.fav .fav-list').on('click', function (e) {
                        e.preventDefault();

                        if (!$('#site-header #fav-list').hasClass('is-active')) {
                            $('#site-header #fav-list').addClass('is-active');
                            $('#site-header #fav-list').fadeIn(100);
                        }
                    });
                }
            }

            $('.mm__header_menu_wrapper #primary-menu .close').click(function () {
                if ($('.mm__header_menu_wrapper #header-navigation').hasClass('is-active')) {
                    $('.mm__header_menu_wrapper #header-navigation').removeClass('is-active');
                }
            });
        });

        /**
         * Click event for opening and closing the sub layers in menu - mobile device
         * 
         */
        $('.mm__header_menu_wrapper #header-navigation #primary-menu .dropdown > a').click(function (e) {
           
            // Trigger only on mobile devices
            if (576 < $(window).width()) {
                return;
            }

            e.preventDefault();

            if (!$(this).parent().children('.dropdown-menu').hasClass('is-active')) {
                $(this).parent().children('.dropdown-menu').addClass('is-active');
            }

            if (!$(this).parent().children('.dropdown-menu').children(':first-child').hasClass('close-wrapper')) {
                $(this).parent().children('.dropdown-menu').prepend($(
                    `
                    <div class="close-wrapper"><p class="back">Tillbaka</p><p class="exit"></p></div>
                    <li class="menu-item no-after"><a href="${$(this).attr('href')}">${$(this).text()}</a></li>
                    `
                ));
            }

            $(this).parent().children('.dropdown-menu').children('.close-wrapper').children('.exit').click(function () {
                if ($('.mm__header_menu_wrapper #header-navigation').hasClass('is-active')) {
                    $('.mm__header_menu_wrapper #header-navigation').removeClass('is-active');
                }
                $('.dropdown-menu').removeClass('is-active');
            });

            $(this).parent().children('.dropdown-menu').children('.close-wrapper').children('.back').click(function (e) {

                if ($(e.target).parent().parent().hasClass('sub-menu')) {
                    $('.sub-menu').removeClass('is-active');
                } else {
                    $('.dropdown-menu').removeClass('is-active');
                }
            });

        });

        /**
         * Hover event for showing, hiding background element on desktop devices
         * 
         */
        // $('#primary-menu .dropdown:not(.dropdown-submenu)').hover(function() {
        // 	$('.bg-area').css('opacity', '1');
        // 	$('.bg-area').css('visibility', 'visible');
        //     $('.bg-area').css('height', $(this).children('.dropdown-menu.depth_0').css('height'));
        // }, function() {
        // 	$('.bg-area').css('opacity', '0');
        // 	$('.bg-area').css('visibility', 'hidden');
        // });

        /**
         * Click event for opening and closing sub menues in footer - mobile device
         * 
         */
        $('#site-footer nav .menu-item').on('click', function (e) {

            // Trigger only on mobile devices
            if (576 < $(window).width()) {
                return;
            }

            e.stopPropagation();
            $(e.target).children('.dropdown-menu').slideToggle(300);
            $(this).toggleClass('rotated');
        });

        /**
         * Click event for opening pick store modal
         * 
         */
        $('.menu-pick-store .open-pick-store').click(function () {
            

            if (!$('#site-header .mm__pick-store-modal:not(.product-modal)').hasClass('is-active')) {
                
                $('#site-header .mm__pick-store-modal:not(.product-modal)').addClass('is-active');
            }
        });

        /**
         * Click event for opening product page store modal
         * 
         */
        $('#add-product-modal').click(function (e) {
            e.preventDefault();
            let slug = $(this).attr("slug");
            $.ajax({
                type: 'POST',
                url: nordsjo.findProductRedirect,
                timeout: 10000,
                data: {
                    action: 'find-product-by-slug',
                    slug: slug,
                }
            }).done( function( result ) {
                if (!$('#site-header .mm__pick-store-modal.product-modal').hasClass('is-active')) {
                    $('#site-header .mm__pick-store-modal.product-modal').addClass('is-active');

                    $(".mm__pick-store-modal.product-modal").find(".stores-wrapper").append(result);

                }
            });
            
        });

        /**
         * Click event for closing pick store modal
         * 
         */
        $('#site-header .mm__pick-store-modal .close-modal').click(function () {
            if ($('#site-header .mm__pick-store-modal').hasClass('is-active')) {
                $('#site-header .mm__pick-store-modal').removeClass('is-active');
            }

            /* For product modal - to empty content */
            if($(this).closest('.mm__pick-store-modal').hasClass("product-modal")) {
                $(this).closest('.mm__pick-store-modal').find(".stores-wrapper").html("");
            }
        });

        /**
         * Click event for displaying search form
         * 
         */
        $('#site-header .display-search').click(function (e) {
            e.preventDefault();

            if (!$(this).hasClass('is-hidden')) {
                $(this).addClass('is-hidden');

                // Trigger only on mobile devices
                if (576 < $(window).width()) {
                    $('.search-box').fadeIn();
                } else {
                    $('.search-box').slideToggle(300);
                }

            }
        });

        /**
         * Click event for hiding search form
         * 
         */
        $('.search-box .post-input').click(function () {
            if ($('#site-header .display-search').hasClass('is-hidden')) {
                $('#site-header .display-search').removeClass('is-hidden');

                // Trigger only on mobile devices
                if (576 < $(window).width()) {
                    $('.search-box').fadeOut();
                } else {
                    $('.search-box').slideToggle(300);
                }
            }
        })

    });
})(jQuery);